import { useContractWrite, useWalletClient } from "wagmi";
import { waitForTransaction } from "wagmi/actions";

import { useGasEstimate } from "./useGasEstimate";
import {
    CONFIRMATIONS_COUNT,
    ERROR_RWA_OPEN_POSITION,
    ERROR_RWA_OPEN_POSITION_WRITE
} from "../utils/config";
import { getContractByField } from "../ethers/contracts";
import { useMemo } from "react";

export const useOpenRwaDeposit = ({ amount, config, showApproval, item }) => {

    const { data: signer } = useWalletClient();
    const { chainId } = config;
    
    const forwardingDepositContract = useMemo(() => {
            return getContractByField(chainId, item.contractField)
        },
        [chainId, item.contractField]
    );

    const DEPOSIT_FUNCTION_NAME = "deposit";

    const {
        estimatedGas,
        estimatesGasFormatted,
        estimatedGasUSD,
        isError
    } = useGasEstimate({
        contract: forwardingDepositContract,
        functionName: DEPOSIT_FUNCTION_NAME,
        args: [amount],
        account: signer?.account,
        amount,
        showApproval,
    });

    const depositContract = useContractWrite({
        address: forwardingDepositContract?.address,
        abi: forwardingDepositContract?.abi,
        functionName: DEPOSIT_FUNCTION_NAME,
        args: [amount],
        onError: (error) => {
            console.error(
                ERROR_RWA_OPEN_POSITION_WRITE, error
            );
        },
    });

    const deposit = async ({
        onConfirmation,
        onDepositComplete,
        onDepositing,
        onError,
    }) => {
        try {
            onConfirmation?.();

            const depositTransaction = await depositContract.writeAsync();
            const { hash } = depositTransaction;

            onDepositing?.(hash);

            const depositResult = await waitForTransaction({
                hash,
                confirmations: CONFIRMATIONS_COUNT,
            });

            onDepositComplete?.(depositResult);

            return true;
        } catch (error) {
            console.error(ERROR_RWA_OPEN_POSITION, error);
            onError?.(error);
            return false;
        }
    };

    return {
        deposit,
        estimatedGas,
        estimatesGasFormatted,
        estimatedGasUSD,
        estimateHasError: isError,
        isLoading: depositContract.isLoading,
    };
};
